import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { Input } from 'reactstrap';
import tableSort from '../../../../_components/common/Sort';
import { superAdminAction, homePageAction } from '../../../../_actions';
import AccessData from '../../../../_components/common/AccessData';


class AddOrganisation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            addToOrgModal: false,
            removeFromOrgModal: false,
            orgId: 'null',
            show: 'null',
            sortType: false,
            checkBoxData: [],
            buttonData: [],
            updateModalState: false,
            updateMessage: null,
            assessmentOrganisationData: '',
            navData: [],
            tableData: [
            ],
            tempTable: null,
        }
    }

    componentDidMount() {
        this.props.dispatch(superAdminAction.getAnalyticsOrganisationHandler(() => {
            this.props.dispatch(superAdminAction.getAssessmentOrganisationHandler(+this.props.match.params.id, () => {
            }))
        }))
        this.setState({
            buttonData: [
                {
                    id: 1,
                    name: 'Add to Analytics Org ',
                    toggler: this.toggleAddToOrgModal.bind(this),
                    togglerModal: this.state.addToOrgModal,
                    icon: 'fa fa-plus',
                    disabled: 'disabled',
                    title: 'Add to Analytics Org'
                }, {
                    id: 2,
                    name: 'Remove from Analytics Org ',
                    toggler: this.toggleRemoveFromOrgModal.bind(this),
                    togglerModal: this.state.removeFromOrgModal,
                    icon: 'fa fa-minus',
                    disabled: 'disabled',
                    title: 'Add to Analytics Org'
                }
            ]
        })

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
        if (prevProps.getAssessmentOrganisationResponse !== this.props.getAssessmentOrganisationResponse) {
            const formatedData = []
            this.props.getAssessmentOrganisationResponse !== '' && this.props.analyticsOrganisationResponse !== '' &&
                this.props.analyticsOrganisationResponse.map(
                    (data, i) => {
                        let count = 0;
                        for (let i = 0; i < this.props.getAssessmentOrganisationResponse.length; i++) {
                            if (this.props.getAssessmentOrganisationResponse[i].assessment_organisation_id === data.id) {
                                count = count + 1;
                            }
                        }
                        if (count > 0) {
                            formatedData.push({
                                ...data,
                                'rowCheck': true,
                                'access': ' fa fa-check text-success'
                            })
                        }
                        if (count === 0) {
                            formatedData.push({
                                ...data,
                                'rowCheck': true,
                                'access': ' fa fa-times text-danger'
                            })
                        }
                    }
                )
            if (this.props.getAssessmentOrganisationResponse !== '') {
                this.setState({
                    assessmentOrganisationData: formatedData
                })
            }
        }
    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }

    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.state.assessmentOrganisationData
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ assessmentOrganisationData: arrayCopy });
    }

    onChangeShow = (ev) => {
        this.setState({
            show: ev.target.value
        }, () => this.getFilteredTableData(this.getReformatedTableData(this.props.getAssessmentOrganisationResponse, this.props.analyticsOrganisationResponse), this.state.show))
    }

    getReformatedTableData = (getAssessmentOrganisationResponse, analyticsOrganisationResponse) => {
        const reformatData = [];
        analyticsOrganisationResponse !== '' &&
            analyticsOrganisationResponse.map(
                (data, i) => {
                    let count = 0;

                    for (let i = 0; i < getAssessmentOrganisationResponse.length; i++) {
                        if (getAssessmentOrganisationResponse[i].assessment_organisation_id === data.id) {
                            count = count + 1;
                        }
                    }
                    if (count > 0) {
                        reformatData.push({
                            ...data,
                            'rowCheck': true,
                            'access': ' fa fa-check text-success'
                        })
                    }
                    if (count === 0) {
                        reformatData.push({
                            ...data,
                            'rowCheck': true,
                            'access': ' fa fa-times text-danger'
                        })
                    }
                }
            )
        return reformatData
    }

    getFilteredTableData(tableData, id) {
        const filteredTableData = [];
        for (let i in tableData) {
            if (id === '1') {
                if (tableData[i].access === " fa fa-check text-success") {
                    filteredTableData.push(tableData[i])
                }
            }
            if (id === '2') {

                if (tableData[i].access === " fa fa-times text-danger") {
                    filteredTableData.push(tableData[i])
                }
            }
            if (id === 'null') {

                filteredTableData.push(tableData[i])
            }
        }
        this.setState({
            assessmentOrganisationData: filteredTableData
        })
    }

    toggleEntireOrgModal(showModal) {
        this.setState({
            addToOrgModal: showModal
        })
    }

    toggleAddToOrgModal(showModal) {
        this.setState({
            addToOrgModal: showModal
        })
    }

    toggleRemoveFromOrgModal(showModal) {
        this.setState({
            removeFromOrgModal: showModal
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    // this method is used to fetch the selected batch id's which has to be remove and send to service
    onClickRemoveFromOrg(type) {
        if (type === 'Remove') {
            const { checkBoxData } = this.state;
            const { getAssessmentOrganisationResponse } = this.props;
            const assessment_organisation = [];
            for (let i = 0; i < checkBoxData.length; i++) {

                if (checkBoxData[i].access === ' fa fa-check text-success') {
                    for (let j = 0; j < getAssessmentOrganisationResponse.length; j++) {

                        if (getAssessmentOrganisationResponse[j].assessment_organisation_id === checkBoxData[i].id) {
                            assessment_organisation.push(+getAssessmentOrganisationResponse[j].id)
                        }
                    }
                }
            }
            const fd = {
                'assessment_organisation_id': assessment_organisation
            }
            this.props.dispatch(superAdminAction.removeAssessmentOrganisationHandler(fd, +this.props.match.params.id, (data) => {
                this.setState({
                    addToOrgModal: false,
                    show: 'null',
                    updateMessage: {
                        status: data.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                        <p> ${data.data.message}.</p>
                    </div>`,
                        heading: 'Add to Analytics Organisation',
                        headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                        headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                })
            }))
        }
        this.setState({
            removeFromOrgModal: false
        })
    }

    // this method is used to fetch the selected batch id's which has to be add and send to service
    onClickAddToOrg(type) {
        if (type === 'Add') {
            const { checkBoxData } = this.state;
            const assessment_organisation = [];
            for (let i = 0; i < checkBoxData.length; i++) {

                if (checkBoxData[i].access === ' fa fa-times text-danger') {

                    assessment_organisation.push(+checkBoxData[i].id)
                }
            }
            const fd = {
                'analytics_organisation': +this.props.match.params.id,
                'assessment_organisation': assessment_organisation
            }
            this.props.dispatch(superAdminAction.addAssessmentOrganisationHandler(fd, (data) => {
                this.setState({
                    addToOrgModal: false,
                    show: 'null',
                    updateMessage: {
                        status: data.status,
                        text: `<div className = " text-center">
                        <p className = "font-weight-bold">${(data.status === 200 || data.status === 201) ? 'Success!' : 'Error!'}</p>
                        <p> ${data.data.message}.</p>
                        </div>`,
                        heading: 'Add to Analytics Organisation',
                        headerColor: (data.status === 200 || data.status === 201) ? `` : `bg-danger`,
                        headingIcon: (data.status === 200 || data.status === 201) ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
                    },
                    updateModalState: true
                })
            }))
        }
        this.setState({
            addToOrgModal: false
        })
    }

    // this method is used to fetch the html tag data for add (and) remove modal
    getAddToOrgData(checkBoxData) {

        const headings = [{
            'name': 'Org Name',
            'textCenter':false
        }, {
            'name': 'Access',
            'textCenter':true

        }]
        const keyNames = [{
            'name': 'organisation_name'
        }]
       return AccessData(checkBoxData, headings, keyNames)
    }

    // This method is used to set the checkbox data in state
    getSelectedData(data) {
        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    // This method is used to check whether the selected data has to be add or remove
    enableAddOrRemove = (checkBoxData, type) => {
        let count = 0;
        for (let i = 0; i < checkBoxData.length; i++) {
            if (checkBoxData[i].access === (type === 'add' ? ' fa fa-check text-success' : ' fa fa-times text-danger')) {
                count = count + 1;
            }
        }
        return count === checkBoxData.length ? false : true;
    }

    render() {

        const { getAssessmentOrganisationResponse, analyticsOrganisationResponse } = this.props;
        const tables = {
            Team: [{
                name: 'Name',
                key: 'organisation_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                rowCheck: 'rowCheck'
            }, {
                name: 'Access',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'icon',
                content: 'access',
                alignCenter: true,
                headingAlign: true,
                // buttonDisabled: 'buttonDisabled',
            }
            ]
        }

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">ADD ORGANISATION</h5>
                        <div className="d-flex flex-row flex-wrap justify-content-center">
                            <div className="col-md-4 col-8 px-0 my-2">
                                <div className="d-flex flex-row justify-content-center">
                                    <label className="col-3 my-1" > Access:</label>
                                    <Input
                                        value={this.state.show}
                                        type="select" name="field"
                                        bsSize="sm" className="col-8 border-1"
                                        onChange={this.onChangeShow}
                                    >
                                        <option className="" value='null' key={0}>All</option>;
                                        <option className="" value={1} key={1}>Allow Access</option>
                                        <option className="" value={2} key={2}>Deny Access</option>
                                    </Input>
                                </div>
                            </div>
                        </div>

                        <UtilityNav
                            actionButtons={this.state.buttonData}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            (getAssessmentOrganisationResponse !== '' && analyticsOrganisationResponse !== '') &&
                            <TableNew
                                data={this.state.assessmentOrganisationData === '' ? this.getReformatedTableData(getAssessmentOrganisationResponse, analyticsOrganisationResponse) : this.state.assessmentOrganisationData}
                                columns={tables.Team}
                                checkbox="true"
                                selectCheckBox={this.selectAllAssessment.bind(this)}
                                getData={this.getSelectedData.bind(this)}
                                CheckKey={"id"}
                                sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                sortType={this.state.sortType}
                            />
                        }

                        {
                            (getAssessmentOrganisationResponse === '' || analyticsOrganisationResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-dark " ></i>
                                &nbsp;loading
                            </p>
                        }

                        {
                            this.state.addToOrgModal &&
                            <ModalComponent
                                showModal={this.state.addToOrgModal}
                                heading="Add to Analytics Organisation"
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                htmlTag={this.getAddToOrgData(this.state.checkBoxData)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'add') ? [{
                                    'buttonName': 'Add',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickAddToOrg(type)}
                            />
                        }

                        {
                            this.state.removeFromOrgModal &&
                            <ModalComponent
                                showModal={this.state.removeFromOrgModal}
                                heading="Remove from Analytics Organisation"
                                toggleEntireModal={this.toggleEntireOrgModal.bind(this)}
                                htmlTag={this.getAddToOrgData(this.state.checkBoxData)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'remove') ? [{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickRemoveFromOrg(type)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }

                    </div>

                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    const { getAssessmentOrganisationLoading } = state.getAssessmentOrganisationReducer;
    const getAssessmentOrganisationError = state.getAssessmentOrganisationReducer.error;
    const getAssessmentOrganisationResponse = (!getAssessmentOrganisationLoading && !getAssessmentOrganisationError) ? state.getAssessmentOrganisationReducer.data.data.assessment_organisation_list : '';

    const { analyticsOrganisationLoading } = state.getAnalyticsOrganisationReducer;
    const analyticsOrganisationReducerError = state.getAnalyticsOrganisationReducer.error;
    const analyticsOrganisationResponse = (!analyticsOrganisationLoading && !analyticsOrganisationReducerError) ? state.getAnalyticsOrganisationReducer.data.data.organisation_list : '';
         //Header Permission
     const { headPerLoading } = state.headerPermissionReducer
     const headPerLoadingError = state.headerPermissionReducer.error
     const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    return {
        getAssessmentOrganisationResponse,
        analyticsOrganisationResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError

    }
}

export default connect(mapStateToProps)(AddOrganisation);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/AddOrganisation/index.js